import { ILinkProps, Link } from '@fluentui/react/lib/Link';

export interface IPLinkProps extends ILinkProps {}

export const IPLink = (props: IPLinkProps) => {
  return <Link {...props} />;
};
